import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b00f44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Rede Social (role):")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Instagram")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("WhatsApp")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Twitter")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("YouTube")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("FaceBook")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Telegram")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Rede WIFI")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Site")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("WPA")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("WEP")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Correção de Erro")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Baixo (7%)")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Medio (15%)")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Alto (25%)")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Muito Alto (30%)")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("QR-Code")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Carrinho")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Limpar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_base_layout = _resolveComponent("base-layout")!

  return (_openBlock(), _createBlock(_component_base_layout, {
    "show-back-arrow": "true",
    "page-title": "QR-Code Rede Social",
    "page-default-back-link": "/frontpage"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ion_select, {
            placeholder: "Rede Social",
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "instagram" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "whatsapp" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "twitter" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "youtube" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "facebook" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "telegram" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "wifi" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "site" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_input, {
            modelValue: _ctx.key,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.key) = $event)),
            placeholder: "instagram/twitter/face/whatsapp/SSID/site"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_input, {
                modelValue: _ctx.wifiKey,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wifiKey) = $event)),
                placeholder: "Senha da Rede"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_radio_group, {
                    value: "biff",
                    modelValue: _ctx.wifiType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wifiType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_radio, {
                            slot: "start",
                            value: "WPA"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_radio, {
                            slot: "start",
                            value: "WEP"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.type=='wifi']
      ]),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_ion_select, {
            placeholder: "Tipo",
            modelValue: _ctx.fec,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fec) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "L" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "M" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "Q" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_ion_select_option, { value: "H" }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.generate,
            disabled: !_ctx.itsOkToGenerate
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_ion_button, {
            size: "small",
            color: "success",
            onClick: _ctx.doCar,
            disabled: _ctx.qrcode == '' || _ctx.canCar==false
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_ion_button, {
            size: "small",
            onClick: _ctx.clear
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { class: "ion" }, {
        default: _withCtx(() => [
          (_ctx.qrcode!='')
            ? (_openBlock(), _createBlock(_component_ion_img, {
                key: 0,
                "router-link": "/car",
                src: _ctx.qrcode,
                width: "150",
                height: "150",
                alt: "qr-code"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_label, { class: "minor" }, {
            default: _withCtx(() => [
              _createTextVNode(" Lat: " + _toDisplayString(_ctx.location.latitude) + " Long:" + _toDisplayString(_ctx.location.longitude) + " Acc:" + _toDisplayString(_ctx.location.accuracy), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}